<template>
    <div
        class="duration-100 ease-linear transform pb-2 bg-white rounded-xl overflow-hidden border lg:bg-gray-50 lg:translate-y-2 hover:shadow-lg hover:bg-white hover:shadow-md group hover:translate-y-0"
    >
        <div class="flex flex-col w-full h-full">
            <div
                @click="gotoProductPage"
                class="cursor-pointer"
            >
                <img
                    :src="product.images.length ? product.images[0].image_path : common.defaultImg"
                    :alt="product.name"
                    class="object-contain w-full"
                />
                <div
                    class="px-2 pt-2 text-sm text-center text-black line-clamp-1 leading-snug"
                    :title="product.name"
                >
                    {{ product.name }}
                </div>
                <div class="relative text-center">
                    <!-- <div class="absolute top-0 transform -translate-x-1/2 -translate-y-1/2 left-1/2"> -->
                    <div class="px-2 py-2 text-sm font-semibold text-green-800 group-hover:bg-white line-clamp-1">
                        {{ product.brand.name }}
                    </div>
                    <!-- </div> -->
                </div>

                <div
                    v-if="$page.props.user && kycVerified"
                    class="py-1 text-2xl font-semibold text-center"
                >
                    {{ config(common.currency) }} {{ parseFloat(product.price).toFixed(2) }}
                </div>
                <div
                    v-else-if="showPrice"
                    class="py-1 text-2xl font-semibold text-center"
                >
                    $$$$
                </div>
            </div>

            <!-- Commented the wholesaler name and address -->
            <!-- <div class="flex items-center justify-between my-2 text-sm">
                <div>
                    <div
                        class="font-semibold line-clamp-1"
                        :title="product.owner.name"
                    >
                        {{ product.owner.name }}
                    </div>
                    <p class="pr-5 text-gray-400 line-clamp-1">
                        {{ product.owner.kyc.business_address }}
                    </p>
                </div>
                <div
                    class="flex-shrink-0"
                    :title="`Chat with ${product.owner.name}`"
                    @click.stop="goto('chat.show', { recipientId : product.owner.id })"
                >
                    <ChatIcon class="w-5 duration-200 transform hover:scale-125" />
                </div>
            </div> -->

            <div class="relative text-center">
                <!-- :class="authUserCanPurchaseProduct(product) ? 'group-hover:opacity-100' : 'group-hover:opacity-50'" -->
                <template v-if="!isSalesperson || $page.props.user.inverse_associated_users[0].id === product.owner.id">
                    <CounterComponent
                        v-if="showCounter && product.available_stock > 0 && $page.props.user && kycVerified"
                        :current-count="getQuantity(product.id)"
                        :product-id="product.id"
                        class="w-full"
                        :max="product.available_stock"
                        @countChanged="updateQuantity(product.id, $event)"
                    />
                    <div class="py-1 text-sm text-center text-black-500 line-clamp-2">
                        Available Stock: {{ product.available_stock }}
                    </div>
                    <div
                        v-if="$page.props.user && kycVerified"
                        :class="[
                            'flex items-center justify-center mx-2 p-2 mt-auto text-sm font-semibold text-center duration-100 ease-in-out transform border rounded group-hover:opacity-100 lg:opacity-100',
                            product.available_stock > 0
                                ? 'cursor-pointer border-green-400'
                                : 'cursor-not-allowed border-gray-200 bg-gray-200 text-gray-400',
                        ]"
                        @click.stop="addToCart(product)"
                    >
                        <CartIcon class="w-5 mr-4" />
                        <div v-if="product.available_stock >= 1">Add to Cart</div>
                        <div v-else>Out of Stock</div>
                    </div>
                </template>

                <div
                    v-else-if="!$page.props.user"
                    class="flex items-center justify-center p-3 mt-auto text-sm font-semibold text-center duration-100 ease-in-out transform border border-green-200 rounded lg:p-2 lg:opacity-0 group-hover:opacity-100"
                    @click.stop="goto('login')"
                >
                    <CartIcon class="w-5 mr-2" />
                    Login to place order.
                </div>

                <div
                    v-else-if="!kycVerified"
                    class="flex items-center justify-center p-3 mt-auto text-sm font-semibold text-center duration-100 ease-in-out transform border border-green-200 rounded lg:p-2 lg:opacity-0 group-hover:opacity-100"
                    @click.stop="
                        isKycSubmitted ? goto('kyc.show', { kycId: $page.props.user.kyc_id }) : goto('kyc.create')
                    "
                >
                    <CartIcon class="w-5 mr-4" />
                    Verify KYC First
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CounterComponent from '@/Components/CounterComponent.vue';
    import CartIcon from './Icons/CartIcon.vue';
    import common from '../common';

    export default {
        components: {
            CounterComponent,
            CartIcon,
        },

        props: {
            product: {
                type: Object,
                required: true,
            },
            showPrice: {
                type: Boolean,
                default: true,
            },
            showCounter: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                common,
                // quantity: 1,
                quantities: {}, // key = product.id, value = quantity
            };
        },

        methods: {
            gotoProductPage() {
                this.$inertia.get(
                    route('products.show', {
                        dummy: `${this.convertToKebabCase(this.product.brand.name)}-${this.convertToKebabCase(
                            this.product.name,
                        )}`,
                        product: this.product.slug,
                    }),
                );
            },

            getQuantity(productId) {
                return this.quantities[productId]?.quantity || 1;
            },

            updateQuantity(productId, qty) {
                this.$set(this.quantities, productId, qty); // ensure reactivity
            },

            addToCart(product) {
                const quantity = this.quantities[product.id]?.quantity || 1;
                console.log('Add to cart quantity:: ', quantity);
                if (product.available_stock >= 1) {
                    this.$inertia.post(
                        route('cartItems.store'),
                        { product_id: product.id, quantity: quantity },
                        { preserveScroll: true },
                    );
                }
            },
        },
    };
</script>
